export const QualityReport = ({ value, record }) => value == null ? '' : ((!!value) ? 'Ja' : 'Nein');
